import styled from '@emotion/styled';

const StyledTitle = styled.div`
  font-size: 12px;
  font-weight: 0;
  line-height: 18px;
  flex-grow: 1;
  margin-left: 8px;
`;

const StyledButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: var(--dk-bg-strong, #e7e9ec);
`;

const FileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0px 16px 16px 16px;
`;

const FileContainer = styled.div`
  display: flex;
  border: 4px;
  padding: 4px 8px 4px 4px;
  background-color: var(--dk-bg-subtle, #f9fafb);
  align-items: center;
  justify-content: center;
  height: 40px;
  box-sizing: content-box;
  border-radius: 4px;
`;

const Container = styled.div<{ mobileMode?: boolean }>`
  border-radius: 6px;
  border: ${({ mobileMode }) => (mobileMode ? '' : '1px solid #e7e9ec')};
  :active {
    border: ${({ mobileMode }) => (mobileMode ? '' : ' 1px solid black')};
  }
  box-shadow: ${({ mobileMode }) =>
    mobileMode ? '' : '0 0 4px 0 rgba(0, 102, 204, 0.25)'};
  margin-top: ${({ mobileMode }) => (mobileMode ? '-12px' : '')};
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
`;

const StyledButton = styled.button`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  border-radius: 4px;
  border: 1px solid var(--dk-line, #e7e9ec);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
`;

const MobileUploadButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid var(--dk-line, #e7e9ec);
  gap: 6px;
  width: fit-content;
`;

export {
  StyledTitle,
  StyledButtonsContainer,
  Divider,
  FileWrapper,
  FileContainer,
  Container,
  Wrapper,
  StyledButton,
  MobileUploadButton,
};
